import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import {AnyAbility, defineAbility} from '@casl/ability';

// Creazione del contesto
export const AbilityContext = createContext<AnyAbility>(defineAbility(() => []));

// Creazione del componente `Can` contestualizzato
export const Can = createContextualCan(AbilityContext.Consumer);

// Funzione per definire le regole di abilità
export function defineAppAbilities(rules: any[]) {
    return defineAbility((can) => {
        rules.forEach(({ action, subject, conditions }: any) => {
            can(action, subject, conditions);
        });
    });
}
